import { Control, FieldErrorsImpl } from 'react-hook-form';
import { ActivityId } from './activity-class.model';
import { PartialRecord } from './type-helpers.model';
import { EnergyActivity } from '@shared/helpers/energy/energy.models';

/**
 * @deprecated Use ActivityExpressionVariables instead
 */
export interface GetActivityExpressionVariables {
  apartments: {
    living_area_per_apartment?: number;
    balcony_area_per_apartment?: number;
    bathroom_area_per_apartment?: number;
  };
  stairwells: {
    apartments_per_stairwell_per_storey?: number;
    elevators_per_stairwell?: number;
  };
  laundry_room: {
    gfa?: number;
  };
  bike_room: {
    gfa?: number;
  };
  storage: {
    gfa?: number;
  };
  building_utilities: {
    gfa?: number;
  };
  garage: {
    gfa?: number;
  };
}

/**
 * @deprecated Use DesignExpressionVariables.activity instead
 */
export interface ActivityExpressionVariables {
  apartments_living_area_per_apartment: number;
  apartments_balcony_area_per_apartment: number;
  apartments_bathroom_area_per_apartment: number;
  stairwells_elevators_per_stairwell: number;
  stairwells_apartments_per_stairwell_per_storey: number;
  laundry_room_gfa: number;
  bike_room_gfa: number;
  storage_gfa: number;
  building_utilities_gfa: number;
  garage_gfa: number;
  gfa_other_activities: number;
}

export interface ActivityFormInputProps {
  control: Control<Activity>;
  errors: Partial<FieldErrorsImpl<Activity>>;
  autoValues: Record<string, string | undefined>;
  withLabels?: boolean;
}

/**
 * @deprecated Use ActivityType instead. TODO Remove fully when everything is migrated to design
 */
export enum ActivityEnum {
  Apartments = 'Apartments',
  Stairwells = 'Stairwells',
  LaundryRoom = 'LaundryRoom',
  BikeRoom = 'BikeRoom',
  Storage = 'Storage',
  BuildingUtilities = 'BuildingUtilities',
  Garage = 'Garage',
  Other = 'Other',
}

/**
 * @deprecated Use ActivityType instead
 * TODO: Remove when everything is migrated to design.activities
 */
export enum FutureActivities {
  Office = 'Office', // Not in use yet (only in energy calculations)
  School = 'School', // Not in use yet (only in energy calculations)
  Industry = 'Industry', // Not in use yet (only in energy calculations)
}

/**
 * @deprecated Use ActivityMix from design/activity.model instead
 */
export type ActivityMix = PartialRecord<
  ActivityEnum | FutureActivities | EnergyActivity,
  number
>;

/**
 * @deprecated Should be removed (investigate usage)
 */
export type ActivityProperty =
  | 'livingAreaPerApartment'
  | 'balconyAreaPerApartment'
  | 'bathroomAreaPerApartment'
  | 'apartmentsPerStairwellPerStorey'
  | 'elevatorsPerStairwell'
  | 'gfa'
  | 'name'
  | 'activityId';

/**
 * @deprecated Kept for backwards compatibility. Use {@link ActivityProperty}.
 */
export type ActivityProp = ActivityProperty;

/**
 * @deprecated Use Activity instead
 */
export interface IProjectActivities {
  apartments: {
    type: ActivityEnum;
    livingAreaPerApartment: number | undefined;
    balconyAreaPerApartment: number | undefined;
    bathroomAreaPerApartment: number | undefined;
  };
  stairwells: {
    type: ActivityEnum;
    apartmentsPerStairwellPerStorey: number | undefined;
    elevatorsPerStairwell: number | undefined;
  };
  laundryRoom: {
    type: ActivityEnum;
    gfa: number | undefined | null;
  };
  bikeRoom: {
    type: ActivityEnum;
    gfa: number | undefined | null;
  };
  storage: {
    type: ActivityEnum;
    gfa: number | undefined | null;
  };
  buildingUtilities: {
    type: ActivityEnum;
    gfa: number | undefined | null;
  };
  garage: {
    type: ActivityEnum;
    gfa: number | undefined | null;
  };
  other: {
    type: ActivityEnum;
    name: string | undefined;
    gfa: number | undefined | null;
    activityId: ActivityId;
  };
}

type ActivityApartments = IProjectActivities['apartments'] & {
  id: string;
};

type ActivityStairwells = IProjectActivities['stairwells'] & {
  id: string;
};

type ActivityLaundryRoom = IProjectActivities['laundryRoom'] & {
  id: string;
};

type ActivityBikeRoom = IProjectActivities['bikeRoom'] & {
  id: string;
};

type ActivityStorage = IProjectActivities['storage'] & {
  id: string;
};

type ActivityBuildingUtilities = IProjectActivities['buildingUtilities'] & {
  id: string;
};

type ActivityGarage = IProjectActivities['garage'] & {
  id: string;
};

type ActivityOther = IProjectActivities['other'] & {
  id: string;
};

/**
 * @deprecated Use Activity from design/activity.model instead
 */
export type Activity =
  | ActivityApartments
  | ActivityStairwells
  | ActivityLaundryRoom
  | ActivityBikeRoom
  | ActivityStorage
  | ActivityBuildingUtilities
  | ActivityGarage
  | ActivityOther;
